
import React from 'react';
import {
  Introduction,
  SecurityPrinciples,
  BusinessVulnerability,
  Implementation,
  CaseStudy,
  BusinessAdvantages,
  GettingStarted,
  Conclusion
} from './zero-trust-security';
import RelatedReading from './zero-trust-security/RelatedReading';

const ZeroTrustSecurity: React.FC = () => {
  return (
    <article className="prose prose-lg max-w-none">
      <Introduction />
      
      <div className="bg-gray-50 p-6 rounded-lg mb-8 border border-gray-200">
        <h3 className="font-semibold text-itmgmt-dark-blue mb-3">Quick Navigation</h3>
        <ul className="space-y-2">
          <li><a href="#security-principles" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Zero-Trust Security Principles</a></li>
          <li><a href="#business-vulnerability" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Small Business Vulnerability</a></li>
          <li><a href="#implementation" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Implementation Guide</a></li>
          <li><a href="#case-study" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Case Study</a></li>
          <li><a href="#business-advantages" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Business Advantages</a></li>
          <li><a href="#getting-started" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Getting Started Today</a></li>
        </ul>
      </div>
      
      <div id="security-principles">
        <SecurityPrinciples />
      </div>
      
      <div id="business-vulnerability">
        <BusinessVulnerability />
      </div>
      
      <div id="implementation">
        <Implementation />
      </div>
      
      <div id="case-study">
        <CaseStudy />
      </div>
      
      <div id="business-advantages">
        <BusinessAdvantages />
      </div>
      
      <div id="getting-started">
        <GettingStarted />
      </div>
      
      <Conclusion />
      
      <RelatedReading />
    </article>
  );
};

export default ZeroTrustSecurity;
